import Vue from 'vue';
import { gsap, Power3 } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

Vue.component('amenities-component', {
    data() {
        return {
        };
    },

    mounted() {
        this.revealAmenity();
    },

    methods: {

        revealAmenity() {
            const elements = [...document.querySelectorAll('.chapter__amenities')];

            elements.forEach((element) => {
                gsap.timeline({
                    scrollTrigger: {
                        trigger: element,
                        start: "top 88%",
                        onEnter: () => {
                            gsap.to('.chapter__amenity', { duration: 0.3, x: '0', autoAlpha: 1, ease: Power3.ease, stagger: 0.1 });
                        }
                    },
                });
            });
        },
    },
});